import { Autocomplete, Input } from "@fullscreendigital/carrefour-dex-fe"
import { DownloadIcon } from "../../../../../icons"
import { Add as AddIcon } from '@mui/icons-material'
import { formatUIDateTime } from "../../../../../utils/helpers"

export const toolbarActions = ({
 canDownload,
 canAdd,
 openAdd,
 totalCount,
 exportFileCSV,
 isCSVExportLoading
}) => {
  let actions = []

  if (canDownload && (totalCount > 0 && totalCount <= 5000)) {
    actions = [
      ...actions,
      {
        label: isCSVExportLoading ? 'Export in curs...' : 'Export CSV',
        icon: <DownloadIcon />,
        onClick: isCSVExportLoading ? () => {} : exportFileCSV
      }
    ]
  }

  if (canAdd) {
    actions = [
      ...actions,
      {
        label: 'Adauga Ambalaj',
        icon: <AddIcon />,
        onClick: () => openAdd()
      }
    ]
  }

  return actions
}

export const columns = [
  {
    title: 'Magazin',
    field: 'shopCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Furnizor',
    field: 'supplierName',
    render: row => `${row.supplierName} (${row?.supplierCode})`,
    align: 'left',
    type: 'string'
  },
  {
    title: 'Societate',
    field: 'parentSociety',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Tip suport',
    field: 'supportCode',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Sold teoretic',
    field: 'stock',
    align: 'left',
    type: 'string'
  },
  {
    title: 'Data actualizare',
    field: 'lastUpdate',
    align: 'left',
    type: 'string',
    render: row => formatUIDateTime(row.lastUpdate)
  }
]

export const getFilters = ({
 shopOptions,
 supportTypeFilterOptions,
 parentSocietyOptions
}) => [
  {
    name: 'shopCode',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza magazin"
        options={shopOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Magazin'
  },
  {
    name: 'supplierName',
    filter: <Input variant="outlined" label="Furnizor" type="text" />,
    type: 'text',
    label: 'Nume furnizor'
  },
  {
    name: 'supplierCode',
    value: '',
    filter: <Input variant="outlined" label="Cod furnizor" type="number" />,
    type: 'number',
    label: 'Cod furnizor'
  },
  {
    name: 'parentSociety',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza societate"
        options={parentSocietyOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Societate'
  },
  {
    name: 'supportName',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Selecteaza tip Suport"
        options={supportTypeFilterOptions || []}
      />
    ),
    type: 'autocomplete',
    label: 'Tip Suport'
  }
]
